export const getSizesAndWidths = productCombinations => {
  if (!productCombinations) return undefined
  const sizeMap = new Map()
  const widthsMap = new Map()

  productCombinations.forEach(combination => {
    if (combination.size && combination.size.sizeId) {
      if (!sizeMap.has(combination.size.sizeId)) {
        sizeMap.set(combination.size.sizeId, combination.size)
      }
    }

    if (combination.productWidth && combination.productWidth.productWidthId) {
      if (!widthsMap.has(combination.productWidth.productWidthId)) {
        widthsMap.set(
          combination.productWidth.productWidthId,
          combination.productWidth
        )
      }
    }
  })

  const uniqueSizes = Array.from(sizeMap.values()).sort(
    (a, b) => a.order - b.order
  )
  const uniqueWidths = Array.from(widthsMap.values())

  return {uniqueSizes, uniqueWidths}
}
